// extracted by mini-css-extract-plugin
module.exports = {"margin-top20px":"style_margin-top20px__2RTNE","margin-bottom":"style_margin-bottom__3bcHN"};